import base from './base';
import axios from "axios";

export default class extends base {
    static get uri() {
        return 'clients';
    }

    static messages(id, params = {}) {
        return axios.get(`${this.uri}/${id}/messages`, {
            params
        });
    }

    static visits(id, params = {}) {
        return axios.get(`${this.uri}/${id}/visits`, {
            params
        });
    }
}
